import { render, staticRenderFns } from "./templateName.vue?vue&type=template&id=c0ec1c5c&scoped=true"
import script from "./templateName.vue?vue&type=script&lang=js"
export * from "./templateName.vue?vue&type=script&lang=js"
import style0 from "./templateName.vue?vue&type=style&index=0&id=c0ec1c5c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ec1c5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ec1c5c')) {
      api.createRecord('c0ec1c5c', component.options)
    } else {
      api.reload('c0ec1c5c', component.options)
    }
    module.hot.accept("./templateName.vue?vue&type=template&id=c0ec1c5c&scoped=true", function () {
      api.rerender('c0ec1c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory/sensory-report/templateName.vue"
export default component.exports